export class ExtractPost {
  hoId: number;
  begDate: string;
  endDate: string;
  chnStores: string[];
  reportID: string;
  userId: string;
  selectedFields: string[];
  fileName: string;
}
